import { useEffect } from 'react'

import type { ReferenceElement } from '@floating-ui/core'
import { getOverflowAncestors } from '@floating-ui/react-dom'

export function useUpdateOnScroll(
  ref: ReferenceElement,
  handler: () => void | undefined,
  eventType: 'scroll' | 'resize',
) {
  // handler on scroll and resize for all relevant nodes
  useEffect(() => {
    if (!ref.current) {
      return () => {
        // No-op
      }
    }

    const parents = getOverflowAncestors(ref)

    parents.forEach(parent => {
      parent.addEventListener(eventType, handler)
    })

    return () => {
      parents.forEach(parent => {
        parent.removeEventListener(eventType, handler)
      })
    }
  }, [ref, eventType, handler])
}
